import { getScribeHttpClients } from '@heidi/api/client';

import { type CreditAllowanceResponse } from '../../contracts';
import { type CommerceHttpClient } from '../config';

const http = (): CommerceHttpClient => getScribeHttpClients().scribeHttpV2;

/** @domain commerce — GET /api/v2/ml-scribe/credit-allowance. */
export const getCreditAllowance = () => {
  return http().get<CreditAllowanceResponse>('/credit-allowance');
};
